import {
  EEquipmentPhysicalTypeCategory,
} from '@/types/equipment.ts';

const category: Record<EEquipmentPhysicalTypeCategory, string> = {
  [EEquipmentPhysicalTypeCategory.BATCH_FURNACE]: 'Batch furnaces',
  [EEquipmentPhysicalTypeCategory.SEMI_CONTINUOUS_FURNACE]: 'Semi-continuous furnaces',
  [EEquipmentPhysicalTypeCategory.CONTINUOUS_FURNACE]: 'Continuous furnaces',
  [EEquipmentPhysicalTypeCategory.STORAGE]: 'Storage',
};

export default {
  placeholder: 'Select physical type of the equipment',
  category,
};
